import { render, staticRenderFns } from "./freight_edit.vue?vue&type=template&id=5a62f0f2&scoped=true&"
import script from "./freight_edit.vue?vue&type=script&lang=js&"
export * from "./freight_edit.vue?vue&type=script&lang=js&"
import style0 from "./freight_edit.vue?vue&type=style&index=0&id=5a62f0f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a62f0f2",
  null
  
)

export default component.exports